module.exports = __webpack_public_path__ + "static/media/copy-code.b31f4862.svg";